const strings = {
    appName: 'PayAgree',

    tableLoadingTip: 'Carregando...',

    discardPromptMessage: 'Deseja descartar as informações do formulário?',
};

export default strings;
